module.exports = __webpack_public_path__ + "89374b928d1a2c0ac450ef54db6e69d2.svg";